import React from 'react';
import { NavLink as Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const BackToVenuesList = ({ backToLink = '/merchant/venues', backToText = 'Back to All Venues' }) => {
  return (
    <div className="pb-5">
      <Link to={backToLink} className='text-xs text-orange-500'>
        <span>
          <i className='fa fa-arrow-left mr-2' />
          { backToText }
        </span>
      </Link>
    </div>
  );
};

BackToVenuesList.propTypes = {
  backToLink: PropTypes.string,
  backToText: PropTypes.string,
}

export default BackToVenuesList;
